<div class="footer-container">
  <div class="footer-div">
    <strong>&copy; 2026 Desarrollado por 
      <a class="footer-link" href="https://www.agencycic.com/home" target="_blank">CIC Agency</a>
    </strong>
  </div>
  <div style="flex: 1; margin-left: 20px;">
    <p class="footer-txt">
      <a class="footer-link" href="/terms">Términos de Servicio</a> | 
      <a class="footer-link" href="/privacy">Políticas de Privacidad</a>
    </p>
  </div>
</div>